const SearchDebounceDelay = 300;
export default SearchDebounceDelay;